/** Page to go through the diag & PMI form flows */
import { createFileRoute, useParams } from '@tanstack/react-router'

import { MobileMultiInspectionSubmission } from '../../../../../../components/request-drawer/multi-request-drawer/action/technician-in-progress/MobileMultiInspectionSubmission'

export const Route = createFileRoute(
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { providerBranchId, requestId } = useParams({
    from: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission',
  })

  return <MobileMultiInspectionSubmission providerBranchId={providerBranchId} requestId={requestId} />
}
